export const useSeo = () => {
  const config = useRuntimeConfig()

  const ogTitle = (title: string) => {
    return `${title} | 유심사`
  }

  const ogUrl = (url: string) => {
    return config.public.baseUrl ? `${config.public.baseUrl}/${url}` : `https://www.usimsa.com/${url}`
  }

  const keyword = (keyword: string) => {
    return `eSIM,해외이심,해외eSIM,아이폰 eSIM, 아이폰이심, 갤럭시 eSIM, 갤럭시이심, USIM, 해외유심,해외USIM,아이폰 USIM, 아이폰유심, 갤럭시 USIM, 갤럭시유심, 유심사, ${keyword}`
  }

  const guideKeyword = (phoneType: string, keyword: string) => {
    return `eSIM, 해외이심, 해외eSIM, ${phoneType} eSIM, ${phoneType}이심, 유심사, 등록방법, ${keyword}, ${phoneType}이심등록방법`
  }

  return {
    ogTitle,
    ogUrl,
    keyword,
    guideKeyword
  }
}
